import { formatDate } from "@/lib/utils/date-formatter";
import { groupByDate } from "@/lib/utils/formatDateGroup";

export const createAgentsSlice = (set, get) => ({
  selectedAgent: null,

  getGroupedAgents: (agents) => {
    const groups = {};
    if (!agents) return {};
    agents.forEach((agent) => {
      const dateKey = formatDate(new Date(agent.lastModified));
      if (!groups[dateKey]) groups[dateKey] = [];
      groups[dateKey].push(agent);
    });
    return groupByDate(agents, "lastModified");
  },

  setSelectedAgent: (agent) => set({ selectedAgent: agent }),

  handleEditAgent: (agent) =>
    set({
      selectedAgent: agent,
    }),

  handleCreateNew: () =>
    set({
      selectedAgent: null,
    }),

  clearSelectedAgent: () =>
    set({
      selectedAgent: null,
    }),
});
